import { useInfiniteQuery } from '@tanstack/react-query'

import { fetchVenueSettlementDeductions } from '@/lib/venue/settlementApi'
import type { SettlementDeductionsFilter } from '@/lib/venue/settlementViewModel'

export function settlementDeductionsQueryKey(venueId: string, filter: SettlementDeductionsFilter) {
  return ['venue', venueId, 'settlements', 'deductions', filter] as const
}

export function useVenueSettlementDeductions(venueId: string, filter: SettlementDeductionsFilter) {
  return useInfiniteQuery({
    queryKey: settlementDeductionsQueryKey(venueId, filter),
    queryFn: ({ pageParam }: { pageParam: string | undefined }) =>
      fetchVenueSettlementDeductions(venueId, filter, pageParam),
    initialPageParam: undefined as string | undefined,
    getNextPageParam: (lastPage) => (lastPage.nextExist ? (lastPage.nextCursor ?? undefined) : undefined),
  })
}
